const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isValidEmail = (value) => {
  return emailPattern.test(value)
}

export const emailValidationRules = {
  required: value => !!value || '必須入力です',
  emailLength: v => v.length <= 100 || '100文字以内で入力してください',
  email: value => isValidEmail(value) || '無効なメールアドレスです',
}

export { emailPattern }
